export function getDiscounts(state) {
  return state.discounts;
}

export function getPagination(state) {
  return state.pagination;
}